<template>
  <y-view :loading="isLoading">
    <query-form :data="formData" :form="searchForm" @search="queryHandle"></query-Form>
    <query-table ref="yTable" :initColumns="initColumns" :dataForm="dataForm" @loadingClose="() => isLoading = false" @loadingOpen="() => isLoading = true" :testTableData="testTableData"></query-table>
    <!-- 弹窗 start -->
    <div class="popup_box">
      <k-popup :layout="popupData.showType < 4 ? 'header,body,close':'header,body,footer,close'" :title="popupData.title" :show.sync="popupData.isShowPopup" @after-ok="popupOk">
        <div style="width: 500px;">
          <div class="row" v-if="popupData.showType === '1'">
            {{popupData.popupForm.follow}}
          </div>
          <div class="row" v-if="popupData.showType === '2'">
            {{popupData.popupForm.message}}
          </div>
          <div class="row" v-if="popupData.showType === '3'">
            {{popupData.popupForm.remarks}}
          </div>
          <div class="row" v-if="popupData.showType === '4'">
            <k-input tag="textarea" :value="popupData.popupForm.remarks" class="box" block placeholder="请输入,最多150字" clearable></k-input>
          </div>
        </div>
      </k-popup>
    </div>
    <!-- 弹窗 end -->
  </y-view>
</template>

<script>
  export default {
    name: 'list',
    data() {
      return {
        isLoading: false,
        searchForm: {},
        formData: [
          {
            typeCode: 'input', title: '姓名', name: 'name', placeholder: '请输入'
          },
          {
            typeCode: 'input', title: '电话', name: 'phone', placeholder: '请输入'
          },
          {
            typeCode: 'select', title: '状态', name: 'status', optionData: [
              {key: '0', value: '待处理'}, {key: '1', value: '已处理'}
            ], placeholder: '请选择'
          }
        ],
        dataForm: {
          url: '',
          query: {},
          height: 'calc(100vh - 370px)'
        },
        // 弹窗数据
        popupData: {
          title: '',
          isShowPopup: false,
          showType: '',
          popupForm: {}
        },
        testTableData: [
          {name: '美赞臣', phone: '123456789124', follow: '报关服务、仓储服务、技术报关服务等等等', message: '这是我的留言巴啦啦巴拉巴拉巴拉', state: '0', remarks: '竞争对手,这是竞争对手，打到竞争对手', date: '2021-04-14'},
        ],
      };
    },
    methods: {
      initColumns() {
        return [
          {
            name: '姓名',
            field: 'name',
            style: {
              width: 180,
              textAlign: 'center'
            }
          },
          {
            name: '电话',
            field: 'phone',
            style: {
              width: 200,
              'white-space': 'normal',
              'word-break': 'break-all',
              textAlign: 'center'
            }
          },
          {
            name: '关注',
            field: 'follow',
            style: {
              width: 120,
              textAlign: 'center'
            },
            customRender: row => (
              <div style="display:flex;justify-content: center;">
                  <span style="width: 120px;white-space: nowrap;word-break:normal;overflow:hidden;text-overflow: ellipsis;">{row.follow}</span>
                  {row.follow.length > 9 && <a onClick={() => this.onCheck('关注', row, '1')}>更多</a>}
              </div>
            )
          },
          {
            name: '留言',
            field: 'message',
            style: {
              width: 120,
              textAlign: 'center'
            },
            customRender: row => (
              <div style="display:flex;justify-content: center;">
                <span style="width: 120px;white-space: nowrap;word-break:normal;overflow:hidden;text-overflow: ellipsis;">{row.message}</span>
                {row.message.length > 9 && <a onClick={() => this.onCheck('留言', row, '2')}>更多</a>}
              </div>
            )
          },
          {
            name: '状态',
            field: 'state',
            style: {
              width: 80,
              textAlign: 'center'
            },
            customRender: row => (
              <div>
                  <span>{['待处理', '已处理'][row.state]}</span>
              </div>
            )
          },
          {
            name: '处理备注',
            field: 'remarks',
            style: {
              width: 120,
              textAlign: 'center'
            },
            customRender: row => (
              <div style="display:flex;justify-content: center;">
                <span style="width: 120px;white-space: nowrap;word-break:normal;overflow:hidden;text-overflow: ellipsis;">{row.message}</span>
                {row.message.length > 9 && <a onClick={() => this.onCheck('处理备注', row, '3')}>更多</a>}
              </div>
            )
          },
          {
            name: '创建时间',
            field: 'date',
            style: {
              width: 100,
              textAlign: 'center'
            }
          },
          {
            name: '操作',
            field: 'action',
            style: {
              textAlign: 'center',
              width: 150
            },
            customRender: row => (
              <div>
                {row.state === '0' && <a onClick={() => this.onCheck('处理结果备注', row, '4')}>待处理</a>}
              </div>
            )
          }
        ];
      },
      onCheck(title, row, type) {
        console.log(title, row);
        this.popupData = {
          showType: type,
          isShowPopup: true,
          title: title,
          popupForm: row
        };
      },
      popupOk() {
        console.log('111');
      },
      queryHandle(params) {
        this.dataForm.query = params;
        this.$refs.yTable.init();
      },
    }
  };
</script>

<style scoped>
  .box {
    height: 260px;
    & :global(.k-textarea) {
      height: 260px !important;
      resize: none;
    }
  }
</style>
